import { render, staticRenderFns } from "./Participate.vue?vue&type=template&id=70752c26&"
import script from "./Participate.vue?vue&type=script&lang=js&"
export * from "./Participate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70752c26')) {
      api.createRecord('70752c26', component.options)
    } else {
      api.reload('70752c26', component.options)
    }
    module.hot.accept("./Participate.vue?vue&type=template&id=70752c26&", function () {
      api.rerender('70752c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/report/Participate.vue"
export default component.exports